<template>
  <v-app>
    <sn-session-timeout-modal />
    <snTwoFactorAuthDialog
      v-model="twoFactorAuthDialog"
      :event-data="twoFactorEventData"
      :value="twoFactorAuthDialog"
      @dialogClosed="twoFactorAuthDialog = false"
    />
    <help-and-support v-model="helpAndSupportDialog" />

    <v-main class="pb-8">
      <sn-gradient-header
        :overlay-radius="24"
        :hide-back-btn="!backRoutes[$router.currentRoute.name]"
        :overlap="['File', 'Login'].includes($router.currentRoute.name) ? 174 : 0"
        @back="back"
      >
        <div
          class="pt-6 pt-sm-10 pb-5 px-4 px-sm-14"
        >
          <div
            v-if="!['Login'].includes($router.currentRoute.name)"
            class="d-flex justify-end align-end"
          >
            <div class="mr-auto">
              <closing-portal-logo />
            </div>
            <div class="ml-8 pt-11 pt-sm-0">
              <div
                class="sn-body-1 sn-text-white"
                style="cursor: pointer"
                data-cy="support-button"
                @click="helpAndSupportDialog = true"
              >
                Support
                <v-icon
                  color="snWhite"
                  size="24"
                  data-cy="question-icon"
                >
                  $snQuestionCircle
                </v-icon>
              </div>
            </div>
            <div class="ml-8">
              <v-menu
                v-model="menuOpen"
                elevation="0"
                min-width="200"
                nudge-top="-6"
                offset-y
                left
              >
                <template v-slot:activator="{ on }">
                  <div
                    data-cy="header-menu"
                    style="cursor: pointer"
                    v-on="on"
                  >
                    <v-row
                      no-gutters
                      justify="center"
                    >
                      <span class="sn-body-1 sn-text-white">My account</span>
                      <v-icon
                        color="snWhite"
                        size="24"
                        class="ml-2"
                      >
                        $snChevronDown
                      </v-icon>
                    </v-row>
                  </div>
                </template>
                <v-list
                  class="pa-0"
                  color="white"
                  elevation="0"
                  dense
                >
                  <v-list-item
                    data-cy="logout"
                    class="px-4 py-2"
                    @click="logout"
                  >
                    <v-list-item-content class="pa-0">
                      <v-row
                        no-gutters
                        align="center"
                      >
                        <v-col
                          class="mr-2"
                          cols="auto"
                        >
                          <v-icon
                            size="24"
                            color="snPrimary"
                          >
                            $snExitLeft
                          </v-icon>
                        </v-col>
                        <v-col class="sn-body-1 pa-0">
                          Logout
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </sn-gradient-header>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import snTwoFactorAuthDialog from '~/components/common/v2/snTwoFactorAuthDialog'
import HelpAndSupport from '~/components/portals/closing/HelpAndSupport'
import ClosingPortalLogo from '~/components/portals/closing/ClosingPortalLogo'
import SnSessionTimeoutModal from '../../common/v2/snSessionTimeoutModal'

export default {
  name: 'App',
  components: {
    snTwoFactorAuthDialog,
    HelpAndSupport,
    ClosingPortalLogo,
    SnSessionTimeoutModal
  },
  data () {
    return {
      store: this.$store,
      twoFactorEventData: null,
      twoFactorAuthDialog: false,
      helpAndSupportDialog: false,
      backRoutes: { File: 'Files' },
      menuOpen: false
    }
  },

  mounted () {
    this.$root.$on('start-two-factor-auth', this.startTwoFactorAuth)
    this.$vuetify.theme.themes.light.primary = '#0F5F5E'
  },

  methods: {
    startTwoFactorAuth (eventData) {
      if (eventData.task) {
        this.twoFactorEventData = eventData
        this.twoFactorAuthDialog = true
      }
    },
    logout () {
      window.location.assign('/logout')
    },
    back () {
      this.$router.push({ name: this.backRoutes[this.$router.currentRoute.name] })
    }
  }
}
</script>

<style>
.no-pointer-events {
  pointer-events: none;
}
</style>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.v-application {
  font-family: $font-family-primary;
}

.v-application::v-deep {
  // prevent svg icons from shrinking
  .v-icon {
    min-width: 24px;
  }
  .sn-modal.share-modal {
    .v-card__title.sn-h3{
      // have sn-h3 use the small screen styles for all screen sizes
      font-weight: $font-weight-semi-bold !important;
      font-size: 1.375em !important;
      line-height: 1.454em !important;
    }
    .v-card__text{
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
}
// Update the 2fa modal buttons to more closely match sn-button styling
#app::v-deep #two-factor-auth-dialog-content > .v-card__text {
  button {
    text-transform: capitalize;
    border: 1px solid black;
    &:hover {
      background-color: black;
      color: white;
    }
    &.primary {
      background-color: black !important;
    }
  }
}

@media only screen and (max-width: 672px) {
  // keep support and my account stacked vertically on smaller screens
  #app::v-deep .gradient > div > div {
    flex-direction: column;
  }
}

</style>
